import { difference } from 'lodash';

export const GSM_STANDARD_CHARS = [
  '@',
  '0',
  '¡',
  'P',
  '¿',
  'p',
  '£',
  '_',
  '!',
  '1',
  'A',
  'Q',
  'a',
  'q',
  '$',
  '"',
  '2',
  'B',
  'R',
  'b',
  'r',
  '¥',
  '?',
  '#',
  '3',
  'C',
  'S',
  'c',
  's',
  'è',
  '?',
  '4',
  'D',
  'T',
  'd',
  't',
  'é',
  '?',
  '%',
  '5',
  'E',
  'U',
  'e',
  'u',
  'ù',
  '6',
  'F',
  'V',
  'f',
  'v',
  'ì',
  '?',
  "'",
  '7',
  'G',
  'W',
  'g',
  'w',
  'ò',
  '(',
  '8',
  'H',
  'X',
  'h',
  'x',
  'Ç',
  ')',
  '9',
  'I',
  'Y',
  'i',
  'y',
  '*',
  ':',
  'J',
  'Z',
  'j',
  'z',
  'Ø',
  '+',
  ';',
  'K',
  'Ä',
  'k',
  'ä',
  'Æ',
  ',',
  '<',
  'L',
  'l',
  'ö',
  'æ',
  '-',
  '=',
  'M',
  'Ñ',
  'm',
  'ñ',
  'Å',
  'ß',
  '.',
  '>',
  'N',
  'Ü',
  'n',
  'ü',
  'å',
  'É',
  '/',
  'O',
  '§',
  'o',
  'à',
  'Δ',
  'Φ',
  'Γ',
  'Λ',
  'Ω',
  'Π',
  'Ψ',
  'Σ',
  'Θ',
  'Ξ',
  'Ö',
  'Ä',
  'Ü',
  'ø',
  ' ',
  '\r',
  '\n',
  '¤',
  '&',
];

export const GSM_EXTENDED_CHARS = ['|', '^', '€', '{', '}', '[', ']', '~', '\\'];

const APOSTROPHES_TO_REPLACE = new RegExp(/ʻ|ʼ|ʽ|ˊ|ˋ|’/g);

export const doesNotContainUnicodeChars = (text: string) => {
  return findUnicodeChars(text).length === 0;
};

export const findUnicodeChars = (text: string): string[] => {
  const remainder = new Set<string>();
  difference([...text.replace(APOSTROPHES_TO_REPLACE, "'")], [...GSM_STANDARD_CHARS, ...GSM_EXTENDED_CHARS]).forEach(unicodeChar =>
    remainder.add(unicodeChar),
  );
  return Array.from(remainder);
};
